var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-img-container"},[_c('div',{ref:"scrollSwiperRef",staticClass:"scroll-wrapper"},_vm._l((_vm.list),function(img,i){return _c('img',{key:(img + "_" + i),staticClass:"scroll-item",attrs:{"src":img.imgUrl}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }